export function getBooleanText(value: any) {
  if (value === true) {
    return { key: 'general.yes' };
  }
  if (value === false) {
    return { key: 'general.no' };
  }
  return { key: 'text.no.translation', context: { value } };
}
